import { useCallback, useState } from "react";
import { toast } from "sonner";
import { RUPORA_DOWNLOAD_ROUTE } from "./constants";

// Downloads the Rupora APK through the same-origin backend route, which
// returns Content-Disposition: attachment — so a plain hidden-anchor click
// starts a native file download. No fetch/blob, no CORS, no navigation,
// no new tab, and the upstream endpoint is never exposed to the browser.
export function useApkDownload() {
  const [downloading, setDownloading] = useState(false);

  const start = useCallback(async () => {
    if (downloading) return;
    setDownloading(true);
    try {
      // Lightweight availability probe so the error toast only appears on
      // a REAL failure — never for a cross-origin/browser quirk.
      const probe = await fetch(RUPORA_DOWNLOAD_ROUTE, { method: "HEAD" });
      const type = probe.headers.get("content-type") || "";
      if (!probe.ok || !type.includes("android.package-archive")) {
        throw new Error("download unavailable");
      }
      const link = document.createElement("a");
      link.href = RUPORA_DOWNLOAD_ROUTE;
      link.download = "Rupora.apk";
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch {
      toast.error("Unable to download the app. Please try again.", {
        id: "apk-download-error",
      });
    } finally {
      setDownloading(false);
    }
  }, [downloading]);

  return { downloading, start };
}
